export default {
  referee: "candidate/profile/referee",
  delReferee: "candidate/profile/referee/delete",
  SINGLE: (id) => `candidate/profile/referee/${id}`,
};
